export enum ERxMedicationType {
  PZN = 'pzn',
  COMPOSITE = 'composite',
  ACTIVE_SUBSTANCE = 'activeSubstance',
  FREETEXT = 'freetext',
}
